import moment from 'moment';

// all xxxSetting functions take an EntityCollection of settings

// login

export const loginKeyBase = 'auth.login.';
export const sessionKey   = loginKeyBase + 'session';
export const recaptchaKey = loginKeyBase + 'recaptcha';

export function sessionSetting(settings) {
  const setting          = settings.safeFindBy({key: sessionKey})?.value ?? {};
  const expireIn         = setting.expire_in          ?? 30 * 60;
  const expireInTerminal = setting.expire_in_terminal ??  1 * 60;

  return {
    expireIn:         moment.duration(expireIn,         'seconds'),
    expireInTerminal: moment.duration(expireInTerminal, 'seconds'),
  };
};

export function recaptchaSetting(settings) {
  const setting = settings.safeFindBy({key: recaptchaKey})?.value ?? {};

  return {
    siteKey: setting.site_key || null,
    enabled: (setting.enabled ?? false) && !_.isNil(setting.site_key),
  };
};

// registration

export const generalRegistrationKey = 'auth.registration';
export const registrationKeyBase    = generalRegistrationKey + '.';
export const tradeTermsKey          = registrationKeyBase + 'trade_terms';
export const sensitiveDataKey       = registrationKeyBase + 'sensitive_data';
export const emailAsUsernameKey     = registrationKeyBase + 'email_as_username';
export const passwordValidationKey  = registrationKeyBase + 'password_validation';

export function generalRegistrationSetting(settings) {
  const setting = settings.safeFindBy({key: generalRegistrationKey})?.value ?? {};

  return {
    enabled:         setting.enabled          ?? true,
    disabledMessage: setting.disabled_message || 'Registrace není povolena',
  };
};

export function tradeTermsSetting(settings) {
  const setting = settings.safeFindBy({key: tradeTermsKey})?.value ?? {};

  const { show, required, initially, link_url, link_text, checkbox_text } = setting;

  return {
    show:         show          ?? true,
    required:     required      ?? true,
    initially:    initially     ?? false,
    linkUrl:      link_url      || null,
    linkText:     link_text     || 'obchodními podmínkami',
    checkboxText: checkbox_text || 'Souhlasím s obchodními podmínkami'
  };
};

export function sensitiveDataSetting(settings) {
  const setting = settings.safeFindBy({key: sensitiveDataKey})?.value ?? {};

  const { show, required, initially, link_url, link_text, checkbox_text, full_text } = setting;

  return {
    show:         show          ?? true,
    required:     required      ?? true,
    initially:    initially     ?? false,
    fullText:     full_text     || null,
    linkUrl:      link_url      || null,
    linkText:     link_text     || 'zpracováním osobních údajů',
    checkboxText: checkbox_text || 'Souhlasím se zpracováním osobních údajů'
  };
};

export function emailAsUsernameSetting(settings) {
  const setting = settings.safeFindBy({key: emailAsUsernameKey})?.value ?? {};
  const { checkbox, always, initially } = setting;

  return {
    always:    always   ?? false,
    checkbox:  checkbox ?? _.isNil(always),
    initially: always   ?? initially ?? false,
  }
};

export function passwordValidationSetting(settings) {
  return settings.safeFindBy({key: passwordValidationKey})?.value ?? [];
}
